import { RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/first.vue'
const HomeComponent = () => import('@/pages/home')
const SignNameComponent = () => import('@/pages/code/signName.vue')
const HomeEditComponent = () => import('@/pages/home/HomeEdit.vue')
const LoginComponent = () => import('@/pages/login/Login.vue')
const CreateEntrustComponent = () => import('@/pages/home/newEntrust/process.vue')
const NotConditionProcessComponent = () => import('@/pages/home/newEntrust/notConditionProcess.vue')
const EntrustDetailComponent = () => import('@/pages/home/entrustDetail.vue')
const MyProjectComponent = () => import('@/pages/home/myProject.vue')
const MySignatureComponent = () => import('@/pages/home/mySignatureComponent.vue')
const routes: RouteRecordRaw[] = [
   {
    path: '/',
    redirect: '/home'
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: import('@/pages/home'),
  //   meta: { requiresAuth: true }
  // },
  {
      path: '/home',
      name:'新建委托',
      component: Layout,
      children: [
          {
            path: '',
            component: HomeComponent
          },
        


      ]
  },
   {
      path: '/createEntrust',
      name:'进度查询',
      component: Layout,
      children: [
          {
            path: '',
            component: CreateEntrustComponent
          }
      ]
  },
  {
      path: '/notConditionProcess',
      name:'不符合试验条件样品',
      component: Layout,
      children: [
          {
            path: '',
            component: NotConditionProcessComponent
          }
      ]
  },
  {
      path: '/myProject',
      name:'我的工程',
      component: Layout,
      children: [
          {
            path: '',
            component: MyProjectComponent
          }
      ]
  },
  {
      path: '/mySignature',
      name:'我的签名',
      component: Layout,
      children: [
          {
            path: '',
            component: MySignatureComponent
          }
      ]
  },
  {
      path: '/entrustDetail',
      name:'委托详情',
      component: Layout,
      children: [
          {
            path: '',
            component: EntrustDetailComponent
          },
          
      ]
  },
  {
      path: '/editEntrustDetail',
      name:'修改委托',
      component: Layout,
      children: [
          {
            path: '',
            component: HomeEditComponent
          }
      ]
  },
  {
    path: '/login',
    name: 'login',
    component: LoginComponent,
    // meta: { requiresAuth: false }
  },
  {
    path: '/signName',
    name: 'signName',
    component: SignNameComponent,
    meta: {
      title: '电子签名',  // 页面标题
      // keepAlive: false,   // 是否缓存
      // isPublic: true      // 标记为公开页面
    }
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   redirect: '/home',
  //   meta: {
  //     title: '首页',
  //     renderMenu: false,
  //     icon: 'CreditCardOutlined',
  //   },
  // },
  // {
  //   path: '/front',
  //   name: '前端',
  //   meta: {
  //     renderMenu: false,
  //   },
  //   component: () => import('@/components/layout/FrontView.vue'),
  //   children: [
  //     {
  //       path: '/login',
  //       name: '登录',
  //       meta: {
  //         icon: 'LoginOutlined',
  //         view: 'blank',
  //         target: '_blank',
  //         cacheable: false,
  //       },
  //       component: () => import('@/pages/login'),
  //     },
  //     {
  //       path: '/home',
  //       name: '首页',
  //       meta: {
  //         view: 'blank',
  //       },
  //       component: () => import('@/pages/home'),
  //     },
  //   ],
  // },
  {
    path: '/403',
    name: '403',
    props: true,
    meta: {
      renderMenu: false,
    },
    component: () => import('@/pages/Exp403.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    props: true,
    meta: {
      icon: 'CreditCardOutlined',
      renderMenu: false,
      cacheable: false,
      _is404Page: true,
    },
    component: () => import('@/pages/Exp404.vue'),
  },
  // {
  //   path: '/entrustAcceptance',
  //   name:"entrustAcceptance",
  //   meta: {
  //     title: '委托受理',
  //     renderMenu: false,
  //     icon: '',
  //   },
  //   component:() => import('@/pages/entrust/acceptance/index.vue'),
  // },
  {
    path: '/paramsEngineering',
    name:"paramsEngineering",
    meta: {
      title: '参数-工程管理',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/engineering/index.vue'),
  },
  {
    path: '/paramsMainItem',
    name:"paramsMainItem",
    meta: {
      title: '参数-大项管理',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/mainItem/index.vue'),
  },
  {
    path: '/itemFields',
    name:"paramsItemFields",
    meta: {
      title: '参数-大项字段配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/itemFields/index.vue'),
  },
  {
    path: '/paramsParam',
    name:"paramsParam",
    meta: {
      title: '参数-参数管理',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/param/index.vue'),
  },
  {
    path: '/paramsMethod',
    name:"paramsMethod",
    meta: {
      title: '参数-方法管理',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/method/index.vue'),
  },
  {
    path: '/paramTemplate',
    name:"paramTemplate",
    meta: {
      title: '参数-模板管理',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/template/index.vue'),
  },
  {
    path: '/paramReportTemplate',
    name:"paramReportTemplate",
    meta: {
      title: '参数-报告模板配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/reportTemplate/index.vue'),
  },
  
  {
    path: '/productionReportView',
    name:"productionReportView",
    meta: {
      title: '报告-报告预览',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/reportView/index.vue'),
  },
  {
    path: '/formRender',
    name:"formRender",
    meta: {
      title: '表单渲染',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/formRender/index.vue'),
    
  },
  {
    path: '/formDemo',
    name:"formRender2",
    meta: {
      title: '表单渲染2',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/formDemo/index.vue'),
    
  },
  // 委托单
  {
    path: '/entrustedReg',
    name:"entrustedReg",
    meta: {
      title: '委托单',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustedReg/index.vue'),
    
  },  
  {
    path: '/entrustedRegDetail',
    name:"entrustedRegDetail",
    meta: {
      title: '委托单详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustedReg/detail.vue'),
  },
  {
    path: '/departmentalTask',
    name:"departmentalTask",
    meta: {
      title: '部门任务',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/departmentalTask/index.vue'),
  },
  {
    path: '/personalTask',
    name:"personalTask",
    meta: {
      title: '个人任务',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/personalTask/index.vue'),
  },
  {
    path:'/entrustTestRecord',
    name:"entrustTestRecord",
    meta: {
      title: '试验记录',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustTestRecord/index.vue'),
  },
  {
    path:'/entrustTestRecordEnter',
    name:"entrustTestRecordEnter",
    meta: {
      title: '记录表数据录入',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustTestRecord/enter.vue'),
  },
  {
    path:'/entrustRecordReview',
    name:"entrustRecordReview",
    meta: {
      title: '记录复核',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/recordReview/index.vue'),
  },
  {
    path:'/entrustRecordReviewEnter',
    name:"entrustRecordReviewEnter",
    meta: {
      title: '记录复核详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/recordReview/enter.vue'),
  },
  {
    path: '/sampleDescription',
    name:"sampleDescription",
    meta: {
      title: '大项样品名称',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/sampleDescription/index.vue'),
  },
  {
    path: '/inputTableDesign',
    name:"inputTableDesign",
    meta: {
      title: '记录表录入设计',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/inputTableDesign/index.vue'),
  },
  {
    path: '/tableFormDesign',
    name:"tableFormDesign",
    meta: {
      title: '记录表记录表设计',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/inputTableDesign/design.vue'),
  },
  {
    path: '/sampleUnit',
    name:"sampleUnit",
    meta: {
      title: '大项样品单位',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/sampleUnit/index.vue'),
  },
  {
    path: '/sampleRetention',
    name:"sampleRetention",
    meta: {
      title: '样品留样/处置配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/sampleRetention/index.vue'),
  },
  {
    path: '/sampleInfoDetail',
    name:"sampleInfoDetail",
    meta: {
      title: '大项样品描述',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/sampleInfoDetail/index.vue'),
  },
  {
    path: '/numberConfig',
    name:"numberConfig",
    meta: {
      title: '编号配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/numberConfig/index.vue'),
  },
  {
    path:'/reportPreparation',
    name:"reportPreparation",
    meta: {
      title: '报告编制',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportPreparation/index.vue'),
  },
  {
    path:'/reportPreparationEnter',
    name:"reportPreparationEnter",
    meta: {
      title: '报告编制详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportPreparation/enter.vue'),
  },
  {
    path:'/reportReview',
    name:"reportReview",
    meta: {
      title: '报告审核',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportReview/index.vue'),
  },
  {
    path:'/reportReviewEnter',
    name:"reportReviewEnter",
    meta: {
      title: '报告审核详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportReview/enter.vue'),
  },
  {
    path:'/reportIssuance',
    name:"reportIssuance",
    meta: {
      title: '报告签发',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportIssuance/index.vue'),
  },
  {
    path:'/reportIssuanceEnter',
    name:"reportIssuanceEnter",
    meta: {
      title: '报告签发详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportIssuance/enter.vue'),
  },
  {
    path:'/reportVerification',
    name:"reportVerification",
    meta: {
      title: '报告校核',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportVerification/index.vue'),
  },
  {
    path:'/reportSealPrint',
    name:"reportSealPrint",
    meta: {
      title: '报告盖章打印',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportSealPrint/index.vue'),
  },
  {
    path:'/reportSignFor',
    name:"reportSignFor",
    meta: {
      title: '报告归档',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportSignFor/index.vue'),
    
  },
  {
    path:'/reportVerificationEnter',
    name:"reportVerificationEnter",
    meta: {
      title: '报告校核详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportVerification/enter.vue'),
  },
  {
    path:'/dataStatReportLedger',
    name:"dataStatReportLedger",
    meta: {
      title: '数据统计-报告台账',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/dataStat/reportLedger.vue'),
  },
  {
    path:'/dataStatWorkloadList',
    name:"dataStatWorkloadList",
    meta: {
      title: '数据统计-报告台账',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/dataStat/workloadList.vue'),
  },
  {
    path:'/dataStatUnqualifiedReportLedger',
    name:"dataStatUnqualifiedReportLedger",
    meta: {
      title: '数据统计-报告不合格台账',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/dataStat/unqualifiedReportLedger.vue'),
  },
  {
    path:'/approvalConfiguration',
    name:"approvalConfiguration",
    meta: {
      title: '数据统计-报告不合格台账',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/approvalConfiguration/index.vue'),
  },
  {
    path:'/complaintList',
    name:"complaintList",
    meta: {
      title: '投诉评价',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/dataStat/complaintList.vue'),
  },
  // 报告修改流程 修改信息
  {
    path: '/reportModification',
    name:"reportModification",
    meta: {
      title: '修改信息',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportModification/index.vue'),
    
  },
  {
    path: '/modifyingTemplateData',
    name:"modifyingTemplateData",
    meta: {
      title: '修改数据',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportModification/modifyingTemplateData/enter.vue'),
    
  },
  {
    path: '/modifyingSamleInfo',
    name:"modifyingSamleInfo",
    meta: {
      title: '修改样品信息',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/reportModification/modifyingSamleInfo/enter.vue'),
    
  },
  {
    path: '/receiptDetail',
    name:"receiptDetail",
    meta: {
      title: '回执单详情',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustedReg/receiptDetail.vue'),
    
  },
  //生产-设备相关
  {
    path: '/productEquipmentList',
    name:"productEquipmentList",
    meta: {
      title: '设备清单',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/deviceManage/deviceList.vue'),
  },
  {
    path: '/productEquipmentLaboratoryList',
    name:"productEquipmentLaboratoryList",
    meta: {
      title: '试验室清单',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/deviceManage/laboratoryList.vue'),
  },
  {
    path: '/productEquipmentInstrumentCategory',
    name:"productEquipmentInstrumentCategory",
    meta: {
      title: '仪器设备类别',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/deviceManage/instrumentCategory.vue'),
  },
  {
    
    path: '/proParamsCommonTestingItems',
    name:"proParamsCommonTestingItems",
    meta: {
      title: '常用检测项目',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/commonTestingItems/index.vue'),
  },
   {
    
    path: '/proSampleFieldMap',
    name:"proSampleFieldMap",
    meta: {
      title: '样品字段映射',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/sampleFieldMap/index.vue'),
  },
   {
    path: '/proEntrustOrderTemplate',
    name:"proEntrustOrderTemplate",
    meta: {
      title: '委托单模板配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/params/entrustOrderTemplate/index.vue'),
  },
   {
    path: '/inputTableDesignCommonUsed',
    name:"inputTableDesignCommonUsed",
    meta: {
      title: '常用检测项-记录表录入设计',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/inputTableDesignCommonUsed/index.vue'),
  },
  {
    path: '/tableFormDesignCommonUsed',
    name:"tableFormDesignCommonUsed",
    meta: {
      title: '常用检测项-记录表记录表设计',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/inputTableDesignCommonUsed/design.vue'),
  },
  {
    path: '/commonUsedTemplate',
    name:"commonUsedTemplate",
    meta: {
      title: '常用检测项-记录模板配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/commonUsedTemplate/index.vue'),
  },
  {
    path: '/commonUsedReportTemplate',
    name:"commonUsedReportTemplate",
    meta: {
      title: '常用检测项-记录模板配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/commonUsedReportTemplate/index.vue'),
  },

  {
    path: '/collectDeviceConfig',
    name:"collectDeviceConfig",
    meta: {
      title: '采集设备配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/collectDeviceConfig/index.vue'),
  },
  {
    path: '/collectJudgeConfig',
    name:"collectJudgeConfig",
    meta: {
      title: '采集判定配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/collectJudgeConfig/index.vue'),
  },
  {
    path: '/dataJsonConfig',
    name:"dataJsonConfig",
    meta: {
      title: '数据JSON配置',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/entrustConfigManage/dataJsonConfig/index.vue'),
  },
  {
    path: '/pressMachine',
    name:"pressMachine",
    meta: {
      title: '压力机',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/testQuery/pressMachine/index.vue'),
  },
  {
    path: '/universalMachine',
    name:"universalMachine",
    meta: {
      title: '万能机',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/testQuery/universalMachine/index.vue'),
  },
  {
    path: '/cementMortarMachine',
    name:"cementMortarMachine",
    meta: {
      title: '水泥胶砂一体机',
      renderMenu: false,
      icon: '',
    },
    component:() => import('@/pages/entrust/testQuery/cementMortarMachine/index.vue'),
  },
  
 

];

export default routes;
